import containerFuild from '../html-snippets/container-fuild';
import buttonPrimaryHtml from '../../../views/website/products/components/description/ui-modules/button-primary/raw-html.js';
import css from '../css-snippets/section-card-cedrow-with-tab';

const buttonRivoneedHtml = buttonPrimaryHtml({
  text: 'Take advantage of the offer',
  backgroundColor: '#00374c',
  color: '#ffffff',
  radius: 100,
  iconSuffix: {
    show: true,
    src: 'https://cdn.skyfastimg.com/images/2026/06/11/image-6a2a87db55a093b7ad8c6903.png',
  },
});

const html = `
<div class="wrap-card container">
  <div data-show="true" data-attribute="card-title" class="card-title">
    <h2 style="text-align: center;">Walk Freely Again. Real Results</h2>
  </div>
  <div class="wrap-header-tabs">
    <div
      data-color-tab-header="#214a88"
      data-color-tab-header-hover="#ffffff"
      data-bg-tab-header-hover="#214a88"
      data-attribute="list-tab-header"
      class="list-tab"
      style="--color-tab-header: #00374c; --color-tab-header-hover: #ffffff; --bg-tab-header-hover: #00374c"
    >
      <div class="tab-header-item active" data-tab="tab-1" data-attribute="tab-header-item">Foot Dragging</div>

      <div class="tab-header-item" data-tab="tab-2" data-attribute="tab-header-item">Fall Risk</div>

      <div class="tab-header-item" data-tab="tab-3" data-attribute="tab-header-item">Ankle Mobility</div>
    </div>
  </div>
  <div class="wrap-content-tabs">
    <div data-attribute="list-tab-content" class="list-tab-content">
      <div data-tab="tab-1" data-attribute="tab-content-item" class="tab-content-item active">
        <div class="wrapper-item">
          <div data-attribute="left-item" class="left-item">
            <div data-attribute="text-header-item" class="text-header-item">
              <h3>80% of participants noticed their foot stopped dragging when walking within first use</h3>
            </div>
            <div data-show="true" class="list-child-item" data-attribute="list-child-item">
              <div class="child-item">
                <div data-attribute="wrap-icon-child-item" class="wrap-icon-child-item">
                  <img
                    data-attribute="icon-child-item"
                    src="https://cdn.skyfastimg.com/images/2026/08/04/image-6a714d3777f2370fc3e09201.png"
                    alt=""
                  />
                </div>
                <div data-attribute="text-child-item" class="text-child-item">Based on observational study</div>
              </div>
              <div class="child-item">
                <div data-attribute="wrap-icon-child-item" class="wrap-icon-child-item">
                  <img
                    data-attribute="icon-child-item"
                    src="https://cdn.skyfastimg.com/images/2026/08/04/image-6a714d3777f2370fc3e09201.png"
                    alt=""
                  />
                </div>
                <div data-attribute="text-child-item" class="text-child-item">Based on observational study</div>
              </div>
              <div class="child-item">
                <div data-attribute="wrap-icon-child-item" class="wrap-icon-child-item">
                  <img
                    data-attribute="icon-child-item"
                    src="https://cdn.skyfastimg.com/images/2026/08/04/image-6a714d3777f2370fc3e09201.png"
                    alt=""
                  />
                </div>
                <div data-attribute="text-child-item" class="text-child-item">Based on observational study</div>
              </div>
            </div>
            <div class="wrap-btn-rivoneed">${buttonRivoneedHtml}</div>
          </div>
          <div data-attribute="right-item" class="right-item">
            <img
              data-attribute="right-image"
              src="https://cdn.skyfastimg.com/images/2026/08/04/image-6a716af12092617aea63980e.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div data-tab="tab-2" data-attribute="tab-content-item" class="tab-content-item">
        <div class="wrapper-item">
          <div data-attribute="left-item" class="left-item">
            <div data-attribute="text-header-item" class="text-header-item">
              <h3>91% of participants reported significantly fewer near-falls and trips while walking within 1 week</h3>
            </div>
            <div data-show="true" class="list-child-item" data-attribute="list-child-item">
              <div class="child-item">
                <div data-attribute="wrap-icon-child-item" class="wrap-icon-child-item">
                  <img
                    data-attribute="icon-child-item"
                    src="https://cdn.skyfastimg.com/images/2026/08/04/image-6a714d3777f2370fc3e09201.png"
                    alt=""
                  />
                </div>
                <div data-attribute="text-child-item" class="text-child-item">Based on observational study</div>
              </div>
              <div class="child-item">
                <div data-attribute="wrap-icon-child-item" class="wrap-icon-child-item">
                  <img
                    data-attribute="icon-child-item"
                    src="https://cdn.skyfastimg.com/images/2026/08/04/image-6a714d3777f2370fc3e09201.png"
                    alt=""
                  />
                </div>
                <div data-attribute="text-child-item" class="text-child-item">Based on observational study</div>
              </div>
              <div class="child-item">
                <div data-attribute="wrap-icon-child-item" class="wrap-icon-child-item">
                  <img
                    data-attribute="icon-child-item"
                    src="https://cdn.skyfastimg.com/images/2026/08/04/image-6a714d3777f2370fc3e09201.png"
                    alt=""
                  />
                </div>
                <div data-attribute="text-child-item" class="text-child-item">Based on observational study</div>
              </div>
            </div>
            <div class="wrap-btn-rivoneed">${buttonRivoneedHtml}</div>
          </div>
          <div data-attribute="right-item" class="right-item">
            <img
              data-attribute="right-image"
              src="https://cdn.skyfastimg.com/images/2026/08/04/image-6a716af12092617aea63980e.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div data-tab="tab-3" data-attribute="tab-content-item" class="tab-content-item">
        <div class="wrapper-item">
          <div data-attribute="left-item" class="left-item">
            <div data-attribute="text-header-item" class="text-header-item">
              <h3>87% of participants experienced measurably improved ankle flexibility within 2 weeks</h3>
            </div>
            <div data-show="true" class="list-child-item" data-attribute="list-child-item">
              <div class="child-item">
                <div data-attribute="wrap-icon-child-item" class="wrap-icon-child-item">
                  <img
                    data-attribute="icon-child-item"
                    src="https://cdn.skyfastimg.com/images/2026/08/04/image-6a714d3777f2370fc3e09201.png"
                    alt=""
                  />
                </div>
                <div data-attribute="text-child-item" class="text-child-item">Based on observational study</div>
              </div>
              <div class="child-item">
                <div data-attribute="wrap-icon-child-item" class="wrap-icon-child-item">
                  <img
                    data-attribute="icon-child-item"
                    src="https://cdn.skyfastimg.com/images/2026/08/04/image-6a714d3777f2370fc3e09201.png"
                    alt=""
                  />
                </div>
                <div data-attribute="text-child-item" class="text-child-item">Based on observational study</div>
              </div>
              <div class="child-item">
                <div data-attribute="wrap-icon-child-item" class="wrap-icon-child-item">
                  <img
                    data-attribute="icon-child-item"
                    src="https://cdn.skyfastimg.com/images/2026/08/04/image-6a714d3777f2370fc3e09201.png"
                    alt=""
                  />
                </div>
                <div data-attribute="text-child-item" class="text-child-item">Based on observational study</div>
              </div>
            </div>
            <div class="wrap-btn-rivoneed">${buttonRivoneedHtml}</div>
          </div>
          <div data-attribute="right-item" class="right-item">
            <img
              data-attribute="right-image"
              src="https://cdn.skyfastimg.com/images/2026/08/04/image-6a716af12092617aea63980e.png"
              alt=""
            />
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css, {
  backgroundColor: '#f3f7fe',
  textColor: '#00374c',
  topPadding: true,
  bottomPadding: true,
});
